import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import AssessmentIcon from '@material-ui/icons/Assessment';
import AvTimerIcon from '@material-ui/icons/AvTimer';
import CommentIcon from '@material-ui/icons/Comment';
import HelpIcon from '@material-ui/icons/Help';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import PersonIcon from '@material-ui/icons/PersonOutlined';
import QueuePlayNextIcon from '@material-ui/icons/QueuePlayNext';
import RestoreIcon from '@material-ui/icons/Restore';
import SearchIcon from '@material-ui/icons/Search';
import LineStyleIcon from '@material-ui/icons/LineStyle';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import StoreIcon from '@material-ui/icons/Store';
import { BiPurchaseTag } from "react-icons/bi";
import { CgLastpass, CgLogIn, CgLogOut } from "react-icons/cg";
import { FaFileInvoiceDollar, FaStore } from "react-icons/fa";
import { FcDebt } from "react-icons/fc";
import { aronURL, YsPortalURL } from 'src/utils/contants';
import { text } from "../../modules/languages/index";
import TouchAppIcon from '@material-ui/icons/TouchApp';
import TransferWithinAStationIcon from '@material-ui/icons/TransferWithinAStation';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import YoutubeSearchedForIcon from '@material-ui/icons/YoutubeSearchedFor';
import SendIcon from '@material-ui/icons/Send';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import PagesIcon from '@material-ui/icons/Pages';
import ViewCarouselIcon from '@material-ui/icons/ViewCarousel';
import TimerOffIcon from '@material-ui/icons/TimerOff';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import BuildIcon from '@material-ui/icons/Build';
import { colors, Typography } from '@material-ui/core';
import Label from 'src/components/Label';
import React from 'react';
import { getUser } from 'src/utils/Common';
import axios from "src/utils/axios";
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';
import { DeleteForever } from '@material-ui/icons';
import AmpStoriesIcon from '@material-ui/icons/AmpStories';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import BatteryAlertIcon from '@material-ui/icons/BatteryAlert';
import BatteryUnknownIcon from '@material-ui/icons/BatteryUnknown';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import RedeemIcon from '@material-ui/icons/Redeem';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ArtTrackIcon from '@material-ui/icons/ArtTrack';
import ToysIcon from '@material-ui/icons/Toys';
export const getMenu = () => {
  return DefaultMenu;
}


const DefaultMenu = [
  {
    title: 'Fiş & Malzeme Yönetimi',
    href: aronURL,
    icon: AddShoppingCartIcon,
  },
  {
    title: 'Stok Sorgulama',
    href: '/MaterialSearch',
    icon: SearchIcon,
  },
  {
    title: 'Ürün Sorgulama',
    href: '/ProductSearch',
    icon: YoutubeSearchedForIcon,
  },
  {
    title: 'Stok İşlemleri',
    href: '/Stok',
    icon: ShoppingCartIcon,
    items: [
      {
        title: '_Stok Girişi',
        href: '/StokGirisi',
        icon: () => (getPassCount(3)),
        items: [
          {
            title: 'Faturaya İstinaden',
            icon: FaFileInvoiceDollar,
            href: '/Invoice',
          },
          {
            title: 'Paslaşmadan Gelen',
            icon: CgLastpass,
            href: '/Pass',
            label: () => (getPassCount(3))
          },
          {
            title: 'Satın Alma',
            icon: BiPurchaseTag,
            href: '/Purchase',
          },
          {
            title: 'Fişten İade',
            icon: BiPurchaseTag,
            href: '/ServicePaperPurchase',
          },
          {
            title: 'Zimmet İade',
            icon: FcDebt,
            href: '/Refund',
          }
        ]
      },
      {
        title: '_Stok Çıkışı',
        icon: () => (getPassCount(4)),
        href: '/StokCikisi',
        items: [
          {
            title: 'Zimmet Çıkış',
            icon: CgLogOut,
            href: '/Debit',
          },
          {
            title: 'Paslaşma Çıkış',
            icon: CgLogOut,
            href: '/PassOut',
            label: () => (getPassCount(4))
          },
          {
            title: 'Elden Satış',
            icon: CgLogOut,
            href: '/Sale',
          },
          {
            title: 'Şubeye Çıkış',
            icon: HomeWorkIcon,
            href: '/Branch',
          },

          {
            title: 'Arçelik İade',
            href: '/ArcelikReturn',
            icon: RestoreIcon,
          },
        ]
      },
    ]
  },
  {
    title: 'Depo İşlemleri',
    href: '/Depo',
    icon: StoreIcon,
    items: [
      {
        title: 'Depo Tanımlama',
        icon: FaStore,
        href: '/Warehouse'
      },
    ]
  },
  {
    title: 'Stok Planlama',
    href: '/StokPlanlama',
    icon: SettingsApplicationsIcon,
    items: [
      {
        title: 'Min Teknisyen Zimmet Tanımlama',
        icon: TransferWithinAStationIcon,
        href: '/TechnicianPlan'
      },
      {
        title: 'Servis Hareketli Malzeme Min Stok Tanımlama',
        icon: LocalShippingIcon,
        href: '/ServiceShopPlan'
      },
    ]
  },
  {
    title: '_Paslasma',
    icon: CgLogIn,
    icon: () => (getPassCount(5)),
    href: '/PassMain',
    items: [
      {
        title: 'Talep Aç',
        icon: QueuePlayNextIcon,
        href: '/OpenPass',
      },
      {
        title: 'Taleplerim',
        icon: ImportContactsIcon,
        href: '/MyPass',
      },
      {
        title: 'SevkEdilenler',
        icon: SendIcon,
        href: '/MyPassSend',
      },
      {
        title: 'Onay Bekleyenler',
        icon: TouchAppIcon,
        href: '/PassConfirm',
        label: () => (getPassCount(1))
      },
      {
        title: 'Ödeme Onayı Bekleyenler',
        icon: CreditCardIcon,
        href: '/PassMoneyConfirm',
        label: () => (getPassCount(2))
      },
      {
        title: 'Kart Kayıt',
        icon: RedeemIcon,
        href: '/CardSave'
      },
      {
        title: 'Fatura Takip',
        icon: ArtTrackIcon,
        href: '/InvoiceTracking'
      }



    ]
  },
  {
    title: 'Sayım',
    href: '/Counting1',
    icon: AvTimerIcon,
    items: [
      {
        title: 'Sayım İşlemleri',
        icon: AvTimerIcon,
        href: '/Counting',
      },
      {
        title: 'Depo Kayıtları Sil',
        icon: DeleteForever,
        href: '/Reset',
      }
    ]

  },
  {
    title: 'Malzeme Eskisi',
    href: '/Scrap1',
    icon: BatteryAlertIcon,
    items: [
      {
        title: 'Malzeme Eskisi İşlemleri',
        icon: BatteryUnknownIcon,
        href: '/Scrap',
      },
      {
        title: 'Malzeme Eskisi Rapor',
        icon: FormatListBulletedIcon,
        href: '/ScrapReport',
      }
    ]
  },
  // {
  //   title: 'Müşteri Hizmetleri',
  //   href: '/',
  //   icon: DashboardIcon,
  //   items: [
  //     {
  //       title: 'Dashboard',
  //       icon: LineStyleIcon,
  //       href: '/CustomerCare',
  //     }
  //   ]
  // },
  {
    title: 'Raporlar',
    href: '/Report',
    icon: AssessmentIcon,
    items: [
      {
        title: 'Envanter',
        icon: DashboardIcon,
        href: '/InventoryReport',
      },
      {
        title: 'Envanter Detay',
        icon: AssessmentIcon,
        href: '/InventoryDetailReport',
      },
      {
        title: 'Fatura Fark',
        icon: FileCopyIcon,
        href: '/InvoiceDiff',
      },
      {
        title: 'Arçelik İade',
        icon: AssessmentIcon,
        href: '/ArcelikReturnReport',
      },
      {
        title: 'Siparişler',
        icon: BuildIcon,
        href: '/OrderList',
      },
      {
     
        title: 'Klima Sarf',
        icon: ToysIcon,
        href: '/AirConditioningConsumables',
      },
      {
        title: 'Envanter Sirkülasyon',
        icon: TrackChangesIcon,
        href: '/Circulation',

      },
      {
        title: 'Sayım Fark',
        icon: AvTimerIcon,
        href: '/CountingDifference',

      },
      {
        title: 'Hareketsizlik Durumu',
        icon: TimerOffIcon,
        href: '/StateOfInactivity',

      },
      {
        title: 'Birden Fazla Adreslenmiş Malzeme',
        icon: BubbleChartIcon,
        href: '/MultipleUsesMaterial',

      },




    ]
  },
  {
    title: text('Kullanici'),
    href: '/profile',
    icon: PersonIcon,
    items: [
      {
        title: 'Kullanıcı',
        icon: PersonIcon,
        href: '/profile/1/timeline'
      }
    ]
  },
  {
    title: 'Mesajlaşma',
    href: '/Chat',
    icon: CommentIcon,
  },
  {
    title: 'Yardım',
    href: '/Yardim',
    icon: HelpIcon,
  },
];



export const getIslerAdet = () => {
  return sessionStorage.getItem('IsAdet') || null;
}

export const setIslerAdet = (Adet) => {
  sessionStorage.removeItem('IsAdet');
  sessionStorage.setItem('IsAdet', Adet);
}

////////////////// UYARI ///////////////////////

export const getUyariAdet = () => {
  return sessionStorage.getItem('UyariAdet') || null;
}

export const setUyariAdet = (Adet) => {
  sessionStorage.removeItem('UyariAdet');
  sessionStorage.setItem('UyariAdet', Adet);
}

////////////////// SATIŞ ADET ///////////////////////

export const getSatisAdet = () => {
  return sessionStorage.getItem('SatisAdet') || null;
}
export const setSatisAdet = (Adet) => {
  sessionStorage.removeItem('SatisAdet');
  sessionStorage.setItem('SatisAdet', Adet);
}

////////////////// MALZEME IHTIYAÇ ///////////////////////

export const getMalzemeIhtiyacAdet = () => {
  return sessionStorage.getItem('MalzemeIhtiyacAdet') || null;
}

export const setMalzemeIhtiyacAdet = (Adet) => {
  sessionStorage.removeItem('MalzemeIhtiyacAdet');
  sessionStorage.setItem('MalzemeIhtiyacAdet', Adet);
}
export const getPassCount = (Type) => {
  const user = getUser();
  axios.get("getPassCount/" + user.ServiceShopId + "/" + Type)
    .then(response => {
      sessionStorage.setItem('Pass' + Type, response.data);
    }).catch(error => {
      sessionStorage.setItem('Pass' + Type, 0);
    });

  if (sessionStorage.getItem('Pass' + Type) !== '0') {
    if (Type === 3) {
      return <Label
        color={colors.green[500]}
        shape="rounded"
      >
        {sessionStorage.getItem('Pass' + Type) || null}
      </Label>;
    } else {
      return <Label
        color={colors.red[500]}
        shape="rounded"
      >
        {sessionStorage.getItem('Pass' + Type) || null}
      </Label>;
    }
  }else{
    return '';
  }



}

export const getPassCountMain = (Type) => {
  if (sessionStorage.getItem('Pass' + Type) !== '0') {
    return <Label
      color={colors.red[500]}
      shape="rounded"
    >
      {sessionStorage.getItem('Pass' + Type) || null}
    </Label>;
  } else {
    return <Label
      color={colors.green[500]}
      shape="rounded"
    >
      {sessionStorage.getItem('Pass' + Type) || null}
    </Label>;

  }
}


//////////////// YORUM /////////////////////////////

export const getYorumAdet = () => {
  return sessionStorage.getItem('YorumAdet') || null;
}

export const setYorumAdet = (Adet) => {
  sessionStorage.removeItem('YorumAdet');
  sessionStorage.setItem('YorumAdet', Adet);
}
